import React, { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../App'
import { ROLES } from '../lib/constants'
import CatalogueTab from '../components/CatalogueTab'
import { PricingTab, StockTab, ImportTab, ExportTab, TeamTab } from '../components/Tabs'

const TABS = [
  { id: 'catalogue', label: 'Catalogue', always: true },
  { id: 'pricing', label: 'Pricing', always: true },
  { id: 'stock', label: 'Stock & Forecast', always: true },
  { id: 'import', label: 'Import', perm: 'canImport' },
  { id: 'export', label: 'Export', perm: 'canExport' },
  { id: 'team', label: 'Team', perm: 'canManageTeam' },
]

export default function Dashboard() {
  const { user, role, rolePerms } = useAuth()
  const [activeTab, setActiveTab] = useState('catalogue')
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => { fetchProducts() }, [])

  async function fetchProducts() {
    setLoading(true)
    try {
      const { data, error } = await supabase.from('products').select('*').order('sku')
      if (error) throw error
      setProducts(data || [])
    } catch (err) {
      console.error('Error fetching products:', err)
    } finally {
      setLoading(false)
    }
  }

  async function handleSignOut() { await supabase.auth.signOut() }

  const visibleTabs = TABS.filter(t => t.always || rolePerms[t.perm])
  const roleInfo = ROLES[role] || ROLES.viewer

  return (
    <div className="dashboard">
      <div className="topbar">
        <div className="topbar-left">
          <div className="logo">YVG <span>PORTAL</span></div>
          <span className={`role-badge role-${role}`}>{roleInfo.label}</span>
          <span className="flostream-badge">
            <span className="api-dot"></span>
            Flostream live
          </span>
        </div>
        <div className="topbar-right">
          <span style={{ fontSize: 12, color: 'var(--color-text-secondary)' }}>{user?.email}</span>
          <button className="btn ghost" onClick={handleSignOut} style={{ fontSize: 12 }}>Sign out</button>
        </div>
      </div>
      <div className="nav">
        {visibleTabs.map(t => (
          <button key={t.id} className={`nav-tab ${activeTab === t.id ? 'active' : ''}`} onClick={() => setActiveTab(t.id)}>
            {t.label}
          </button>
        ))}
      </div>
      <div className="tab-body">
        {activeTab === 'catalogue' && <CatalogueTab products={products} loading={loading} onRefresh={fetchProducts} />}
        {activeTab === 'pricing' && <PricingTab products={products} />}
        {activeTab === 'stock' && <StockTab products={products} onRefresh={fetchProducts} />}
        {activeTab === 'import' && rolePerms.canImport && <ImportTab onImportComplete={fetchProducts} />}
        {activeTab === 'export' && rolePerms.canExport && <ExportTab products={products} />}
        {activeTab === 'team' && rolePerms.canManageTeam && <TeamTab />}
      </div>
    </div>
  )
}
